import { EnrolmentStatusDetailsType } from "@/models/operations/enrolment/enrolment.types"

export const EnrolmentBroker = {
  BIG_CLEAN_SWITCH: "big_clean_switch",
  JUST_MOVE_IN: "just_move_in",
  SO_ENERGY: "so_energy",
  RAF_CODE: "raf_code",
  ELMO: "elmo",
  ESB: "esb",
  COMPARE_THE_MARKET: "compare_the_market",
  MONEY_SUPER_MARKET: "money_super_market",
  MY_UTILITY_GENIUS: "my_utility_genius",
  U_SWITCH: "u_switch",
  CONECTIA: "conectia",
} as const

export const Brokers = {
  big_clean_switch: "Big Clean Switch",
  just_move_in: "Just Move In",
  so_energy: "So Energy",
  raf_code: "Raf Code",
  elmo: "Elmo",
  esb: "ESB",
  compare_the_market: "Compare The Market",
  money_super_market: "Money Super Market",
  my_utility_genius: "My Utility Genius",
  u_switch: "Uswitch",
  mug_online_sales: "MUG Online Sales",
  money_expert_3: "Money Expert",
  cot_mwu_self_serve: "COT MWU Self-serve",
} as const

export const getBrokerLabel = (brokerCode?: string | null): string => {
  if (!brokerCode) return "No Broker"
  return (
    Brokers[brokerCode] ??
    brokerCode
      .split("_")
      .map((word) => word.charAt(0)?.toUpperCase() + word?.slice(1))
      .join(" ")
  )
}

export const EnrolmentStatus = {
  DONE: "DONE",
  PENDING: "PENDING",
  CANCELLED: "CANCELLED", // COT Only
  PROCESSING: "PROCESSING", // COT Only
  REGISTERED_IN_JUNIFER: "REGISTERED_IN_JUNIFER",
  FAILED_IN_JUNIFER: "FAILED_IN_JUNIFER",
  FAILED_TO_CREATE_CORE_ACCOUNTS: "FAILED_TO_CREATE_CORE_ACCOUNTS",
  FAILED_TO_SEND_PASSWORD_RESET_EMAIL: "FAILED_TO_SEND_PASSWORD_RESET_EMAIL",
  FAILED_TO_APPLY_VOUCHER: "FAILED_TO_APPLY_VOUCHER",
  FAILED_TO_CREATE_USER: "FAILED_TO_CREATE_USER",
  FAILED_TO_SEND_EMAIL: "FAILED_TO_SEND_EMAIL",
  FAILED: "FAILED", // Soon to be deprecated
  ACCOUNT_CANCELLED: "ACCOUNT_CANCELLED",
  ACCOUNT_TERMINATED: "ACCOUNT_TERMINATED",
  ACCOUNT_CLOSED: "ACCOUNT_CLOSED",
} as const

export const ENROLMENT_STATUS_COMPLETED = "ENROLMENT_COMPLETED"

export const SupplyInitiation = {
  INITIATED: "Initiated",
  NOT_INITIATED: "Not Initiated",
  UNKNOWN: "Unknown",
} as const

export const EnrolmentStatusDetailsMap: {
  [X in keyof typeof EnrolmentStatus]: EnrolmentStatusDetailsType
} = {
  [EnrolmentStatus.DONE]: {
    supply: SupplyInitiation.INITIATED,
    short: "Done",
    long: "Enrolment completed (including online account and activate account email)",
  },
  [EnrolmentStatus.REGISTERED_IN_JUNIFER]: {
    supply: SupplyInitiation.INITIATED,
    short: "No login",
    long: "Registered in Junifer, no online account created or activation email sent",
  },
  [EnrolmentStatus.FAILED_TO_CREATE_CORE_ACCOUNTS]: {
    supply: SupplyInitiation.INITIATED,
    long: "Registered in Junifer but no online account created or activation email sent",
    short: "Registered",
  },
  [EnrolmentStatus.FAILED_TO_SEND_PASSWORD_RESET_EMAIL]: {
    supply: SupplyInitiation.INITIATED,
    long: "Registered in Junifer but failed to send password reset email",
    short: "No password email",
  },
  [EnrolmentStatus.FAILED_TO_APPLY_VOUCHER]: {
    supply: SupplyInitiation.INITIATED,
    long: "Registered in Junifer but RAF credit failed",
    short: "Missing credit",
  },
  [EnrolmentStatus.FAILED_TO_CREATE_USER]: {
    supply: SupplyInitiation.INITIATED,
    long: "Registered in Junifer but no online account created",
    short: "No login",
  },
  [EnrolmentStatus.FAILED_TO_SEND_EMAIL]: {
    supply: SupplyInitiation.INITIATED,
    long: "Registered in Junifer and online account created but no account activation email sent",
    short: "No activation email",
  },
  [EnrolmentStatus.FAILED]: {
    supply: SupplyInitiation.UNKNOWN,
    short: "Old Failed",
    long: "Old enrolments that did not complete the full enrolment flow - may be successful in Junifer",
  },
  [EnrolmentStatus.FAILED_IN_JUNIFER]: {
    supply: SupplyInitiation.NOT_INITIATED,
    long: "Enrolment rejected by Junifer",
    short: "Junifer rejection",
  },
  [EnrolmentStatus.PENDING]: {
    supply: SupplyInitiation.NOT_INITIATED,
    short: "Pending",
    long: "Enrolment unsuccessful, re-submission required",
  },
  [EnrolmentStatus.CANCELLED]: {
    supply: SupplyInitiation.UNKNOWN,
    short: "Cancelled",
    long: "COT move with us scheduled enrolment cancelled",
  },
  [EnrolmentStatus.PROCESSING]: {
    supply: SupplyInitiation.UNKNOWN,
    short: "Processing",
    long: "COT move with us scheduled enrolment pending",
  },
  [EnrolmentStatus.ACCOUNT_CANCELLED]: {
    supply: SupplyInitiation.UNKNOWN,
    short: "Account cancelled",
    long: "Account has been created but the switch was cancelled",
  },
  [EnrolmentStatus.ACCOUNT_TERMINATED]: {
    supply: SupplyInitiation.UNKNOWN,
    short: "Account terminated",
    long: "Account was terminated",
  },
  [EnrolmentStatus.ACCOUNT_CLOSED]: {
    supply: SupplyInitiation.UNKNOWN,
    short: "Account closed",
    long: "Account was closed and all debts are paid",
  },
} as const

export const JUNIFER_ENROLMENT_FAILURE_MESSAGE_REGEX =
  "^MPAN|MPRN|Batch update|UNAVAILABLE|Required"
